import { render, staticRenderFns } from "./FormCard.vue?vue&type=template&id=1fe3d01c&"
import script from "./FormCard.js?vue&type=script&lang=js&"
export * from "./FormCard.js?vue&type=script&lang=js&"
import style0 from "./FormCard.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports